module.exports = __webpack_public_path__ + "img/reserved_3.799825ec.jpg";